import React from 'react'

export default function PrinterSettingsStyle(props) {
  let width, font_size
  let printable_height
  let position

  (() => {
    switch(props.paperWidth)
    {
      case '8.5inch':
        width = '100%'
        font_size = '0.85rem'
        position = 'static'
        break
      case '58mm':
        width = '100%'
        font_size = '0.7rem'
        printable_height = 'height: 100vh'
        position = 'absolute'
        break
      default:
    }
  })()

  return (
    <style jsx='true'>
    {`
      @media screen {
        div.divFooter {
          display: none;
        }
      }

      @media print {
        body * { visibility: hidden; }
        body .container { display: block; }
        body #content { display: block; }

        /***** remove all unnecessary elements *****/
        /* remove content content-header */
        body #content #content-header { display: none; }

        /* remove content content-footer */
        body #content #content-footer { display: none; }

        /* remove toolbars and menu */
        body #menu, body #toolbar { display: none; }

        /* hide these Customer Credit Accounts elements */
        body .credit-account-title, body .tabs-button-container { display: none; }

        div.divFooter {
          display: block;
          position: fixed;
          bottom: 0;
        }

        .reports-item-container {
          padding-top: 0;
        }

        .firstpage { page-break-after: always; }

        .pagebreak {
          page-break-after: always;
          padding-top: 10px;
        }

        .printable, .printable * {
          visibility: visible;
          font-size: ${font_size};
        }

        .printable {
          position: ${position};
          top: 0;
          left: 0;
          margin: 0 auto;
          width: ${width};
          ${printable_height};
          color: black !important;
        }

        .expiration-date-container { width: 180px; }

        .black-and-white * {
          color: black !important;
        }
      }

      @page { margin-left: 0; margin-right: 0; }
    `}
    </style>
  )
}
